import React from 'react';
import Reveal from '../../../shared/Reveal/Reveal';
import checkIcon from '../../../../assets/images/solutiondetails/view/CheckCircle.svg';
import './View.css';

const View = ({ title, description, items, checkIcon: checkIconUrl }) => {
  if (!title || !items?.length) {
    return null;
  }

  return (
    <section className="solution-view">
      <div className="solution-view__inner">
        <div className="solution-view__panel">
          <Reveal className="solution-view__content">
            <h2 className="solution-view__title">{title}</h2>
            {description ? <p className="solution-view__text">{description}</p> : null}
            <ul className="solution-view__list">
              {items.map((item) => (
                <li key={item} className="solution-view__item">
                  <img
                    className="solution-view__check"
                    src={checkIconUrl || checkIcon}
                    alt=""
                    aria-hidden="true"
                  />
                  <span>{item}</span>
                </li>
              ))}
            </ul>
          </Reveal>
        </div>
      </div>
    </section>
  );
};

export default View;
